var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolbar',[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/financial"}},[_c('i',{staticClass:"fa fa-caret-left fa-2x"}),_c('h2',[_vm._v("Financial")])]),_c('div',{staticClass:"controls"},[_c('nav-tabs',{attrs:{"tabs":_vm.expensesTabs,"mobile-breakpoint":_vm.mobileBreakpoint}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }